import React from 'react';
import FactoryDeviationRouter from './FactoryDeviationRouter';

export default function FactoryDeviationPage() {
  return <FactoryDeviationRouter />;
}
